export default {
  directory: (state) => state.directory,
  schedule: (state) => state.schedule,
  schedule_orders: (state) => state.schedule_orders,
};
